import Axios from "axios";
import { SETTINGS } from "../properties/Settings";
import { get } from "ol/proj";

export const ConsignmentRepository = {
  save: (data) => {
    return Axios({
      url: `${SETTINGS.API_URL}consignments/save`,
      method: "POST",
      data: data,
    });
  },
  saveDraft: (data) => {
    return Axios({
      url: `${SETTINGS.API_URL}consignments/saveDraft`,
      method: "POST",
      data: data,
    });
  },
  getConsignmentById: (id) => {
    return Axios({
      url: `${SETTINGS.API_URL}consignments/${id}`,
      method: "GET",
    });
  },
  addConsignmentToTicket: (data, ticketId) => {
    return Axios({
      url: `${SETTINGS.API_URL}consignments`,
      method: "POST",
      data: data,
      params: {
        ticketId: ticketId,
      },
    });
  },
  addDraftConsignmentToTicket: (data, ticketId) => {
    return Axios({
      url: `${SETTINGS.API_URL}consignments/ticket/draft`,
      method: "POST",
      data: data,
      params: {
        ticketId: ticketId,
      },
    });
  },
  deleteConsignment: (id, ticketId) => {
    return Axios({
      url: `${SETTINGS.API_URL}consignments/delete/${id}`,
      params: {
        ticketId: ticketId,
      },
      method: "DELETE",
    });
  },
  getConsignmentStatuses: () => {
    return Axios({
      url: `${SETTINGS.API_URL}consignments/statuses`,
      method: "GET",
    });
  },

  getConsignmentMainTransportDocuments: () => {
    return Axios({
      url: `${SETTINGS.API_URL}consignments/mainTransportDocuments`,
      method: "GET",
    });
  },

  getConsignmentPackageTypes: () => {
    return Axios({
      url: `${SETTINGS.API_URL}consignments/packageTypes`,
      method: "GET",
    });
  },
  getAllConsignments: (
    page,
    size,
    filterParams,
    orderBy = "dateCreated",
    orderDirection = "DESC"
  ) => {
    return Axios({
      url: `${SETTINGS.API_URL}consignments/all`,
      method: "GET",
      params: {
        page: page,
        size: size,
        searchParams: filterParams,
        orderBy: orderBy,
        orderDirection: orderDirection,
      },
    });
  },

  getCustomsOffices: () => {
    return Axios({
      url: `${SETTINGS.API_URL}customsOffice/all`,
      method: "GET",
    });
  },

  getAllEnabledCustomsOffices: () => {
    return Axios({
      url: `${SETTINGS.API_URL}customsOffice/allEnabled`,
      method: "GET",
    });
  },

  getByTicket: (ticketId) => {
    return Axios({
      url: `${SETTINGS.API_URL}consignments/getByTicket/${ticketId}`,
      method: "GET",
    });
  },

  getCreditBalance: (organizationId) => {
    return Axios({
      url: `${SETTINGS.API_URL}consignments/creditBalance/${organizationId}`,
      method: "GET",
    });
  },

  reject: (id) => {
    return Axios({
      url: `${SETTINGS.API_URL}consignments/reject/${id}`,
      method: "POST",
    });
  },

  duplicate: (consignmentId) => {
    return Axios({
      url: `${SETTINGS.API_URL}consignments/duplicate/${consignmentId}`,
      method: "POST",
    });
  },
  sendPresentation: (id) => {
    return Axios({
      url: `${SETTINGS.API_URL}consignments/sendPresentation/${id}`,
      method: "POST",
    });
  },
  fetchPresentation: (id) => {
    return Axios({
      url: `${SETTINGS.API_URL}consignments/fetchPresentation/${id}`,
      method: "GET",
    });
  },
  getPublicPresentation: (token) => {
    return Axios.get(
      `${SETTINGS.API_URL}consignments/public/presentation/${encodeURIComponent(token)}`,
    );
  },
  sendPublicPresentation: (token) => {
    return Axios.post(
      `${SETTINGS.API_URL}consignments/public/presentation/${encodeURIComponent(token)}/send`,
    );
  },
};
